export default __webpack_public_path__ + "static/media/Nestle.1442229f.png";